import React from 'react';
import { Label } from 'components/CustomComponents/FormRow';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const getTitle = () => (
  <h5>
    <strong className="content-section-title">Data Available to Copy Paste</strong>
  </h5>
);

function CopyPaste(props) {
  const { hideView, CopyPasteFields } = props;
  return (
    <div style={{ width: '28em', minWidth: '28em' }} className="m-2">
      <div className="row">
        <div className="col-12">
          <Label label={getTitle()} display="initial" />
          <button
            title="Hide Copy/Paste"
            onClick={() => {
              hideView(false);
            }}
            className="btn turquoise"
            type="button"
            style={{ position: 'absolute', top: '0', right: '0' }}
          >
            <FontAwesomeIcon icon={faCaretRight} />
            Hide
          </button>
        </div>
      </div>
      <CopyPasteFields />
    </div>
  );
}

export default CopyPaste;
